import { render } from "./DropdownLink.vue?vue&type=template&id=98e417ae"
import script from "./DropdownLink.vue?vue&type=script&lang=js"
export * from "./DropdownLink.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__